module.exports = __webpack_public_path__ + "img/activity_21.47680b55.jpg";